import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableCellBaseComponent } from '@wcg/frontend-framework';
import { MatIconModule } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';

@Component({
  selector: 'wcg-document-chat-cell',
  imports: [CommonModule, MatIconModule, MatBadgeModule],
  templateUrl: './document-chat-cell.component.html',
  styleUrls: ['./document-chat-cell.component.css'],
})
export class DocumentChatCellComponent extends TableCellBaseComponent<any> {
  messagesResolved(dataItem: any): boolean {
    return dataItem.isResolved;
  }

  get badgeValue(): string | number {
    return this.componentConfig?.rowData?.messages ? 1 : '';
  }

  get iconClass(): string {
    return this.messagesResolved(this.componentConfig.rowData)
      ? 'green-badge'
      : '';
  }
}
